/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeviceHolderAgreementRequest,
  DeviceHolderAgreementResponse,
  ProblemDetails,
  TenantSettingsRequest,
  TenantSettingsResponse
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The agreement device holders accept at first start, with its `version`, visible character count and who saved it last.
 * @summary Read the Device Holder Agreement in force
 */
export const getDeviceHolderAgreement = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceHolderAgreementResponse>(
      {url: `/v1/tenants/me/device-holder-agreement`, method: 'GET', signal
    },
      options);
    }




export const getGetDeviceHolderAgreementQueryKey = () => {
    return [
    `/v1/tenants/me/device-holder-agreement`
    ] as const;
    }


export const getGetDeviceHolderAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceHolderAgreementQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceHolderAgreement>>> = ({ signal }) => getDeviceHolderAgreement(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeviceHolderAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceHolderAgreement>>>
export type GetDeviceHolderAgreementQueryError = ProblemDetails


export function useGetDeviceHolderAgreement<TData = Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceHolderAgreement>>,
          TError,
          Awaited<ReturnType<typeof getDeviceHolderAgreement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceHolderAgreement<TData = Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceHolderAgreement>>,
          TError,
          Awaited<ReturnType<typeof getDeviceHolderAgreement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceHolderAgreement<TData = Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the Device Holder Agreement in force
 */

export function useGetDeviceHolderAgreement<TData = Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceHolderAgreement>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceHolderAgreementQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * **A save that changes the content is a new version.** The HTML is sanitised to the editor's formats (h1-h3, p, br, strong, em, u, ul, ol, li, a[href]) and stored as the next version.
 * @summary Save the Device Holder Agreement
 */
export const putDeviceHolderAgreement = (
    deviceHolderAgreementRequest: DeviceHolderAgreementRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceHolderAgreementResponse>(
      {url: `/v1/tenants/me/device-holder-agreement`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: deviceHolderAgreementRequest, signal
    },
      options);
    }




export const getPutDeviceHolderAgreementMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDeviceHolderAgreement>>, TError,{data: DeviceHolderAgreementRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putDeviceHolderAgreement>>, TError,{data: DeviceHolderAgreementRequest}, TContext> => {

const mutationKey = ['putDeviceHolderAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putDeviceHolderAgreement>>, {data: DeviceHolderAgreementRequest}> = (props) => {
          const {data} = props ?? {};

          return  putDeviceHolderAgreement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutDeviceHolderAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof putDeviceHolderAgreement>>>
    export type PutDeviceHolderAgreementMutationBody = DeviceHolderAgreementRequest
    export type PutDeviceHolderAgreementMutationError = ProblemDetails

    /**
 * @summary Save the Device Holder Agreement
 */
export const usePutDeviceHolderAgreement = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDeviceHolderAgreement>>, TError,{data: DeviceHolderAgreementRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putDeviceHolderAgreement>>,
        TError,
        {data: DeviceHolderAgreementRequest},
        TContext
      > => {
      return useMutation(getPutDeviceHolderAgreementMutationOptions(options), queryClient);
    }
    /**
 * The tenant's default numbers, the tenant's offline lock (`offline_transition`) with the platform bounds its grace period must fall within.
 * @summary Read the tenant-wide settings in force
 */
export const getTenantSettings = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantSettingsResponse>(
      {url: `/v1/tenants/me/settings`, method: 'GET', signal
    },
      options);
    }




export const getGetTenantSettingsQueryKey = () => {
    return [
    `/v1/tenants/me/settings`
    ] as const;
    }


export const getGetTenantSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTenantSettings>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSettings>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantSettings>>> = ({ signal }) => getTenantSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantSettings>>>
export type GetTenantSettingsQueryError = ProblemDetails


export function useGetTenantSettings<TData = Awaited<ReturnType<typeof getTenantSettings>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSettings>>,
          TError,
          Awaited<ReturnType<typeof getTenantSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantSettings<TData = Awaited<ReturnType<typeof getTenantSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSettings>>,
          TError,
          Awaited<ReturnType<typeof getTenantSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantSettings<TData = Awaited<ReturnType<typeof getTenantSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSettings>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the tenant-wide settings in force
 */

export function useGetTenantSettings<TData = Awaited<ReturnType<typeof getTenantSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSettings>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * **A patch.** An absent property is left as it is.
 * @summary Change tenant-wide settings
 */
export const patchTenantSettings = (
    tenantSettingsRequest: TenantSettingsRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantSettingsResponse>(
      {url: `/v1/tenants/me/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tenantSettingsRequest, signal
    },
      options);
    }




export const getPatchTenantSettingsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTenantSettings>>, TError,{data: TenantSettingsRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTenantSettings>>, TError,{data: TenantSettingsRequest}, TContext> => {

const mutationKey = ['patchTenantSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTenantSettings>>, {data: TenantSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  patchTenantSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchTenantSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchTenantSettings>>>
    export type PatchTenantSettingsMutationBody = TenantSettingsRequest
    export type PatchTenantSettingsMutationError = ProblemDetails

    /**
 * @summary Change tenant-wide settings
 */
export const usePatchTenantSettings = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTenantSettings>>, TError,{data: TenantSettingsRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTenantSettings>>,
        TError,
        {data: TenantSettingsRequest},
        TContext
      > => {
      return useMutation(getPatchTenantSettingsMutationOptions(options), queryClient);
    }
